export enum APIServiceType {
  AGGREGATION = 'aggregation',
  CUSTOMER_DATA = 'customerData',
  GEOLOCATION = 'geolocation',
  RECENTLY_PLAYED = 'recentlyPlayed',
  TRENDING_GAMES = 'trendingGames',
  USER_CONTEXT = 'userContext',
}

export enum CustomerDataEndpoint {
  FEATURES = 'features',
  PACKAGE = 'package',
  PREFERENCES = 'preferences',
}
